module.exports = __webpack_public_path__ + "static/media/vrIconDesign.0e3c62f7.png";